/** @module teal/compile **/

module.exports = {
  compileTemplate: require('./compileTemplate'),
  compileProgram: require('./compileProgram'),
  compileLogicSig: require('./compileLogicSig'),
};
